import { axiosConsignadoInstance } from "../axiosInstance";
import { UpdateTypeRouterResponseDTO } from "./dto/type-router-response.dto";
import {
  UpdateConfigEngineDTO,
  CreateConfigEngineDTO,
  GetConfigEngineResponse,
} from "./dto/config-engine.dto";

export const getConfigEngineById = async (
  id: number
): Promise<GetConfigEngineResponse> => {
  try {
    const request = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/config-engine/list-by-type-router/${id}`
    );
    // console.log("getConfigEngineById - Raw response:", request.data);
    return request.data as GetConfigEngineResponse;
  } catch (error) {
    console.error("Erro ao buscar configuração do engine por id", error);
    throw error;
  }
};

export const getTypeRouters = async () => {
  try {
    const request = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/config-engine/list-type-routers`
    );
    return request.data;
  } catch (error) {
    console.error("Erro at getting type routers", error);
    throw error;
  }
};

export const updateTypeRouterResponse = async (
  id: number,
  body: UpdateTypeRouterResponseDTO
): Promise<void> => {
  try {
    await axiosConsignadoInstance.put(
      `/api-consignado-trabalhador/v1/config-engine/type-router-response/${id}`,
      body
    );
  } catch (error) {
    console.error("Erro at updating criteria engine", error);
    throw error;
  }
};

export const updateConfigEngine = async (
  id: number,
  body: UpdateConfigEngineDTO
): Promise<void> => {
  try {
    await axiosConsignadoInstance.patch(
      `/api-consignado-trabalhador/v1/config-engine/${id}`,
      body
    );
  } catch (error) {
    console.error("Erro ao atualizar configuração do engine", error);
    throw error;
  }
};

export const createConfigEngine = async (
  body: CreateConfigEngineDTO
): Promise<void> => {
  try {
    await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/config-engine`,
      body
    );
  } catch (error) {
    console.error("Erro ao criar configuração do engine", error);
    throw error;
  }
};

export const deleteConfigEngine = async (id: number): Promise<void> => {
  try {
    await axiosConsignadoInstance.delete(
      `/api-consignado-trabalhador/v1/config-engine/${id}`
    );
  } catch (error) {
    console.error("Erro ao deletar configuração do engine", error);
    throw error;
  }
};

export const getListEntityConfigEngine = async () => {
  try {
    const request = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/config-engine/list-entities`
    );
    return request.data;
  } catch (error) {
    console.error(
      "Erro ao buscar lista de entidades de configuração do engine",
      error
    );
    throw error;
  }
};
